//@ts-ignore
import { w3cwebsocket as W3CWebSocket } from "websocket";
import {nanoid}                             from "nanoid";

const events: any = {"message" : {}};
let client: any = null 

export const initSocket = (data : {token: string, sid: string}) => {
    const {token, sid} = data

    if(!token)
        return;

    client = new W3CWebSocket(`${process.env.REACT_APP_WEBSOCKET_URL}?token=${token}&sid=${sid}`, 'echo-protocol');

    client.onerror = () => {
        console.log('Connect Error');
        Object.values(events["socket_error"] || {}).forEach((fn: any) => fn(data));
    };

    client.onopen = (data1: any) =>  {
        Object.values(events["socket_success"] || {}).forEach((fn: any) => fn(data));
        console.log('WebSocket Client Connected');
    };

    client.onclose = () => {
        Object.values(events["socket_error"] || {}).forEach((fn: any) => fn(data));
        console.log('Connection Closed. Try to reconnect');
        setTimeout(() => initSocket({token, sid}), 5000)
    };
    client.onmessage = (message : {type: string, data: any}) => {
        if (message.type === 'message') {
            let data = JSON.parse(message.data);

            console.log(data)
            Object.values(events[data.type] || {}).forEach((fn: any) => fn(data));
            Object.values(events["message"] || {}).forEach((fn: any) => fn(data));
        }
    };
};

export const on = (type: string, fn : (data: any) => any) => {
    let event_id = nanoid(8);
    events[type] = events[type] || {};
    events[type][event_id] = fn;
    return {
        off : () => delete events[type][event_id]
    }
};


